/* eslint-disable linebreak-style */
/** Logo Carousel functionality */

// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}

// Logo carousel module
so.logoCarousel = {
    init: function() {
        this.initCarousels();
    },

    initCarousels: function() {
        // Handle multiple logo carousel instances on the same page
        $('.element-careers-logo-carousel').each(function() {
            var $container = $(this);
            var $swiperContainer = $container.find('.careers-logo-swiper');
            var $prevBtn = $container.find('.carousel-prev');
            var $nextBtn = $container.find('.carousel-next');
            var $count = $container.find('.swiper-slide').length;

            // Exit if no swiper container or Swiper is not available
            if ($swiperContainer.length === 0 || typeof Swiper === 'undefined') {
                return;
            }

            // Initialize Swiper
            var swiper = new Swiper($swiperContainer[0], {
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 4,
                centeredSlides: true,
                loop: ($count > 4), 
                // autoplay: ($count > 4) ? {
                //     delay: 8000,
                //     disableOnInteraction: false,
                // } : false,
                speed: 800,
                initialSlide: 1,
                watchSlidesProgress: true,
                watchOverflow: true,
                grabCursor: true,
                allowTouchMove: true,

                breakpoints: {
                    576: {
                        slidesPerView: 1.5,
                        slidesPerGroup: 1,
                        spaceBetween: 4,
                    },
                    768: {
                        slidesPerView: 2.1,
                        slidesPerGroup: 1,
                        spaceBetween: 4,
                    },
                    992: {
                        slidesPerView: 2.1,
                        slidesPerGroup: 1,
                        spaceBetween: 4,
                    },
                    1200: {
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                        spaceBetween: 4,
                    },
                },

                // Navigation
                navigation: {
                    nextEl: $nextBtn[0],
                    prevEl: $prevBtn[0],
                },

                // Pagination
                pagination: {
                    el: $container.find('.carousel-indicator')[0],
                    bulletClass: 'slide-indicator',
                    bulletActiveClass: 'active',
                    clickable: true,
                },

                // Accessibility
                a11y: {
                    prevSlideMessage: 'Previous logo',
                    nextSlideMessage: 'Next logo',
                    slideLabelMessage: 'Logo {{index}} of {{slidesLength}}',
                },
            });

            // Store swiper instance for potential future use
            $swiperContainer.data('swiper', swiper);
        });
    },
};

$(document).ready(function () {
    so.logoCarousel.init();
});